<template>
  <div id="success">
    <van-icon name="checked" color="#07C180" size="50" />
    <h5>绑定成功！</h5>
    <h5 @click="init()">请重新登录</h5>
  </div>
</template>

<script>
import { setToken } from "@/utils/auth";
export default {
  name: "Success",
  data() {
    return {};
  },
  created() {},
  methods: {
    async init() {
      setToken();
      this.$router.push("/index");
    },
  },
};
</script>

<style scoped>
#success {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

h5 {
  line-height: 10vw;
}
</style>
